import { mapState } from 'vuex';
import { get, cloneDeep } from 'lodash';
export default {
  name: 'CoreDeviceTemplateKeyValueEditor',
  props: {
    header: {
      type: String,
      optional: false,
      default: ''
    },
    description: {
      type: String,
      optional: false,
      default: ''
    },
    keyLabel: {
      type: String,
      optional: false,
      default: ''
    },
    valueLabel: {
      type: String,
      optional: false,
      default: ''
    },
    deviceMeta: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    },
    property: {
      type: String,
      optional: false,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  watch: {
    deviceMeta() {
      this.initialMetaDataSetup();
    }
  },
  methods: {
    get,
    initialMetaDataSetup() {
      if (!this.deviceMeta[this.property]) {
        this.deviceMeta[this.property] = {
          '': {
            defaultValue: '',
            requiredValue: true
          }
        };
      }
    },
    keyValueKeyChanged(prior, newKey) {
      const trimmedKey = newKey.trim();
      if (prior === trimmedKey) {
        return;
      }
      let baseKey = trimmedKey;
      let uniqueKey = baseKey;
      let i = 0;
      while (this.deviceMeta[this.property][uniqueKey] !== undefined && uniqueKey !== prior) {
        i++;
        uniqueKey = `${baseKey}${i}`;
      }
      this.deviceMeta[this.property][uniqueKey] = this.deviceMeta[this.property][prior];
      delete this.deviceMeta[this.property][prior];
      this.deviceMeta[this.property] = cloneDeep(this.deviceMeta[this.property]);
    },
    addKeyValuePair() {
      if (!this.deviceMeta[this.property]) {
        this.$set(this.deviceMeta, this.property, {});
      }
      if (this.deviceMeta[this.property][''] === undefined) {
        this.$set(this.deviceMeta[this.property], '', {
          defaultValue: '',
          requiredValue: true
        });
      }
    },
    removeKeyValuePair(key) {
      delete this.deviceMeta[this.property][key];
      this.deviceMeta[this.property] = cloneDeep(this.deviceMeta[this.property]);
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    }
  }
};